import {v4 as uuidv4} from 'uuid';

import {WorkOutcome} from 'notebook/workers/core/types';
import {logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {CONTENT_WORKER_STARTED_EVENT, CONTENT_WORKER_FINISHED_EVENT} from 'performance/processNotebookEvents';

function _getExtras(
  name: string,
  outcome?: WorkOutcome
): {
  actionMetadata: {name: string; outcome?: WorkOutcome};
  distributionMetadata: {name: string; outcome?: WorkOutcome};
} {
  const metadata = outcome ? {name, outcome} : {name};
  return {actionMetadata: metadata, distributionMetadata: metadata};
}

/**
 * Log timing events around the start and end of a content worker.
 * @param name The name of the content worker.
 * @returns A function to log the end of the content worker.
 */
export default function logWork(name: string): (outcome: WorkOutcome) => void {
  const id = `content-work-${name}-${uuidv4()}`;
  logProfilerTimingEvent({...CONTENT_WORKER_STARTED_EVENT, id}, _getExtras(name));
  return (outcome: WorkOutcome) => {
    logProfilerTimingEvent({...CONTENT_WORKER_FINISHED_EVENT, id}, _getExtras(name, outcome));
  };
}
